import moment from "moment";
const useInsuredStartDate = (startFrom: number = 0, skipThisDayWhenMidday: Boolean = true) => {
  const date = moment().add(startFrom, 'd').startOf('day')
  if (skipThisDayWhenMidday && date.hour() > 12) {
    return date.add(1, "d").toDate();
  }
  return date.toDate()
}

export default useInsuredStartDate